module.exports = __webpack_public_path__ + "img/bevfam_point_btn.61c261ed.png";